import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import TaxPayerApiKey from "../../models/taxpayer-api-key";
import TaxPayerApiKeyForm from "./TaxPayerApiKeyForm";

interface TaxPayerApiKeyUpdateModalProps {
  show: boolean;
  onCancel: () => void | Promise<void>;
  onSuccess: (_?: TaxPayerApiKey) => void | Promise<void>;
}

const TaxPayerApiKeyUpdateModal: React.FC<TaxPayerApiKeyUpdateModalProps> = ({
  show,
  onCancel,
  onSuccess,
}) => {
  const onClose = () => {
    onCancel();
  };

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Nueva API Key</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          {show ? (
            <TaxPayerApiKeyForm onCancel={onCancel} onSuccess={onSuccess} />
          ) : (
            <></>
          )}
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default TaxPayerApiKeyUpdateModal;
